import Swal from 'sweetalert2';

import { Grid } from "gridjs";
import "gridjs/dist/theme/mermaid.css";
import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js";

/**
 * Initializes internal area CP
 */
export function Init() {

    // checks whether user is only in group internal_area and not in group external_website
    // Removes site selector if this is the case --> avoids confusions
    Statamic.$axios.get('/internal/user').then(response => {
        let groups = response.data.groups;

        if(groups.length == 1)
            document.querySelector('.site-selector').remove();
    }).catch(error => {
        Statamic.$toast.error(error.response.data.message);
    });

    if(typeof window.parent.redirectBack === "function") {
        Statamic.$hooks.on('entry.saved', function(resolve, reject, payload) {
                window.parent.redirectBack();
        });
    }
}

/** Configuration Page **/

function configurationLoaded(iframe) {
    const frame = window.frames[0];
    var iframeContentHeight = frame.document.body.offsetHeight;

    frame.document.body.classList.add('embedded');
    
    // constantly update iframe height to fit content
    setInterval(function(){
        if (frame.document.body.offsetHeight != iframeContentHeight) {    
            iframeContentHeight = frame.document.body.offsetHeight;
            iframe.style.height = iframeContentHeight + 'px';
        }
    }, 200);
    document.getElementById('loading-overlay').classList.add('hidden');
}

function initInternalArea() {
    initAllDatePickers();

    window.initDatePickers = initAllDatePickers;
    window.showAuthorDetails = showAuthorDetails;
    window.initRoomBookingsTable = initAllRoomBookingsTable;
    window.initUserConfirmations = initUserConfirmations;
    window.confirmAction = confirmAction;
    window.openLaundryConfirm = openLaundryConfirm;
    window.openLaundrySuccess = openLaundrySuccess;
    window.openLaundryError   = openLaundryError;

    initConfigPage();
    initUserConfirmations();
    initUsersTable();
    initAllRoomBookingsTable();
}

function initUserConfirmations() {
    const userConfirmations = document.querySelectorAll('[data-confirm]');
    userConfirmations.forEach((element) => {
        element.addEventListener('click', function(event) {
            event.preventDefault();
            confirmAction(element);
        });
    });
}

function initAllDatePickers() {
    document.querySelectorAll('.date-picker').forEach((input) => {
        const date = input.value ?? input.getAttribute('value');
        const minDate = input.getAttribute('data-min-date');
        const maxDate = input.getAttribute('data-max-date');
        const inline = input.getAttribute('data-inline') == '1';

        let options = {
            locale: German,
            dateFormat: 'Y-m-d',
            disableMobile: true,
            inline: inline,
            altInput: true,
            altFormat: 'd.m.Y' 
        };

        if(minDate) options.minDate = minDate;
        if(minDate) options.maxDate = maxDate;

        const datePicker = flatpickr(input, options);
        if (date)
            datePicker.setDate(date);
    });
}

function initUsersTable() {
    const table = document.querySelector('#table-users');
    const tableWrapper = document.querySelector('#table-users-wrapper');

    if(!table | !tableWrapper)
        return;

    new Grid({
        from: table,
        pagination: {
            enabled: true,
            limit: 12,
            summary: false
        },
        search: {
            enabled: true
        },
        resizable: true,
        sort: true,
        language: {
            'search': {
              'placeholder': 'Suchen'
            },
            'pagination': {
              'previous': '<',
              'next': '>'
            },
            noRecordsFound: 'Keine Einträge gefunden',
        }
    }).render(tableWrapper);
}

function initAllRoomBookingsTable() {
    var table = document.querySelector('#table-room-bookings');
    if (!table)
        return;

    var tableWrapper = document.querySelector('#table-room-bookings-wrapper');
    if (tableWrapper)
        tableWrapper.remove();

    tableWrapper = document.createElement('div');
    tableWrapper.id = 'table-room-bookings-wrapper';
    document.querySelector('#table-room-bookings').parentNode.appendChild(tableWrapper);

    const grid = new Grid({
        from: table,
        pagination: {
            enabled: true,
            limit: 12,
            summary: false
        },
        resizable: true,
        language: {
            'search': {
              'placeholder': 'Suchen'
            },
            'pagination': {
              'previous': '<',
              'next': '>'
            },
            noRecordsFound: 'Keine Einträge gefunden',
        }
    }).render(tableWrapper);
}

function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

function sanitizeImageUrl(url) {
    if (!url || typeof url !== 'string') return null;
    const t = url.trim();
    if (t.startsWith('http://') || t.startsWith('https://') || t.startsWith('/')) {
        return t;
    }
    return null;
}

function avatarUrlFromAuthorData(authorData) {
    const a = authorData.avatar;
    if (!a) return null;
    if (typeof a === 'string') return sanitizeImageUrl(a);
    if (Array.isArray(a) && a.length) {
        const first = a[0];
        if (typeof first === 'string') return sanitizeImageUrl(first);
        if (first && typeof first === 'object') {
            return sanitizeImageUrl(first.url ?? first.permalink ?? '');
        }
    }
    if (a && typeof a === 'object' && !Array.isArray(a)) {
        return sanitizeImageUrl(a.url ?? a.permalink ?? '');
    }
    return null;
}

function authorAvatarBlockHtml(authorData) {
    const url = avatarUrlFromAuthorData(authorData);
    if (!url) {
        return '';
    }
    const alt = [authorData.first_name, authorData.last_name].filter(Boolean).join(' ').trim() || 'Profilbild';
    return `<div class="mb-4 flex justify-center"><img src="${escapeHtml(url)}" alt="${escapeHtml(alt)}" class="w-44 h-44 rounded-full object-cover" width="176" height="176" loading="lazy"></div>`;
}

function showAuthorDetails(authorData) {
    const name = [authorData.first_name, authorData.last_name].filter(Boolean).join(' ').trim() || 'Unbekannt';
    const avatarBlock = authorAvatarBlockHtml(authorData);
    const nameBlock = `<p class="text-2xl font-semibold m-0 leading-snug">${escapeHtml(name)}</p>`;
    const bodyGuest = `<div class="flex flex-col items-center text-center gap-2">${avatarBlock}${nameBlock}<p class="text-gray-600 m-0">Gastbuchung</p></div>`;
    if (authorData.is_guest || !authorData.email) {
        Swal.fire({
            title: false,
            html: bodyGuest,
            confirmButtonText: 'Schließen'
        });
        return;
    }
    const tel = authorData.tel ?? authorData.tel_landline ?? '';
    Swal.fire({
        title: false,
        html: `
            <div class="flex flex-col items-center text-center gap-2">
            ${avatarBlock}
            ${nameBlock}
            <div class="flex flex-col gap-1 mt-3 w-full">
            <p class="m-0"><a href="mailto:${escapeHtml(authorData.email)}" class="underline">${escapeHtml(authorData.email)}</a></p>
            <p class="m-0"><a href="tel:${escapeHtml(tel)}" class="underline">${escapeHtml(tel)}</a></p>
            </div>
            </div>
        `,
        confirmButtonText: 'Schließen'
    });
}

function initConfigPage() {
    const frameElement = document.getElementById('config-frame');
    if(!frameElement)
        return;

    frameElement.addEventListener('load', () => {
        configurationLoaded(frameElement);
    });
}

function confirmAction(button) {
    const url = button.getAttribute('href');
    const confirmationText = button.getAttribute('data-confirm');
    Swal.fire({
        text: confirmationText,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Abbrechen',
        'theme': 'bulma'
    }).then((result) => {
        if (result.isConfirmed) {
            window.location = url;
        }
    });
}

function openLaundryConfirm(data) {
    const { componentId, selectedSlots, slots, logged_in, room_title, date } = data;

    const slotList = slots.map(s =>
        `<li style="text-align:left;margin-bottom:.25rem;"><strong>${s.machine_label}:</strong> ${s.start}–${s.end}</li>`
    ).join('');

    const guestField = !logged_in
        ? `<div class="form" style="margin-top:1rem;text-align:left;">
            <label for="swal-guest-name" class="laundry-modal-label" style="display:block;margin-bottom:.25rem;">Reservierung für *</label>
            <input id="swal-guest-name" type="text" class="input-field" style="width:100%;box-sizing:border-box;" placeholder="Vorname Nachname">
           </div>`
        : '';

    Swal.fire({
        title: 'Reservierung bestätigen',
        customClass: {
            title: 'laundry-confirm-title',
            htmlContainer: 'laundry-modal-content',
            actions: 'laundry-confirm-actions'
        },
        html: `
            <div style="text-align:left;">
                <p style="margin-bottom:.5rem;">${date} &mdash; ${room_title}</p>
                <ul style="padding-left:1.25rem;">${slotList}</ul>
                ${guestField}
            </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Jetzt reservieren',
        cancelButtonText: 'Abbrechen',
        focusConfirm: false,
        preConfirm: () => {
            if (!logged_in) {
                const name = Swal.getPopup().querySelector('#swal-guest-name').value.trim();
                if (!name) {
                    Swal.showValidationMessage('Bitte gib Vorname und Nachname ein.');
                    return false;
                }
                return name;
            }
            return '';
        }
    }).then(result => {
        if (result.isConfirmed) {
            const guestName = result.value ?? '';
            const slots = selectedSlots ?? [];
            const component = componentId ? Livewire.find(componentId) : null;
            if (component) {
                component.call('submitBookingsFromEvent', guestName, slots);
            } else {
                Livewire.dispatch('submit-laundry-booking', { guestName, selectedSlots: slots });
            }
        }
    });
}

function openLaundrySuccess(data) {
    const { slots, room_title, date } = data;
    const slotList = slots.map(s =>
        `<li style="margin-bottom:.25rem;"><strong>${s.machine}:</strong> ${s.time}</li>`
    ).join('');
    Swal.fire({
        title: 'Reservierung erfolgreich!',
        html: `
            <div style="text-align:left;">
                <p style="margin-bottom:.5rem;">${date} &mdash; ${room_title}</p>
                <ul style="padding-left:1.25rem;">${slotList}</ul>
            </div>
        `,
        icon: 'success',
        confirmButtonText: 'Schließen',
        timer: 10000,
        timerProgressBar: true,
        customClass: {
            title: 'laundry-confirm-title',
            htmlContainer: 'laundry-modal-content',
            actions: 'laundry-confirm-actions',
        },
    }).then(() => window.location.reload());
}

function openLaundryError(data) {
    const errors = data.errors ?? [];
    const errorList = errors.map(e => `<li style="margin-bottom:.25rem;">${e}</li>`).join('');
    Swal.fire({
        title: 'Buchung fehlgeschlagen',
        html: `<ul style="text-align:left;padding-left:1.25rem;">${errorList}</ul>`,
        icon: 'error',
        confirmButtonText: 'OK',
        customClass: {
            title: 'laundry-confirm-title',
            htmlContainer: 'laundry-modal-content',
            actions: 'laundry-confirm-actions',
        },
    });
}

function laundryGridData() {
    return {
        selectedSlots: [],
        toggleSlot(startTime, machineId) {
            const idx = this.selectedSlots.findIndex(
                s => s.start_time === startTime && s.machine_id === machineId
            );
            if (idx !== -1) {
                this.selectedSlots.splice(idx, 1);
            } else {
                this.selectedSlots.push({ start_time: startTime, machine_id: machineId });
            }
        },
        isSelected(startTime, machineId) {
            return this.selectedSlots.some(
                s => s.start_time === startTime && s.machine_id === machineId
            );
        },
        get hasSelection() {
            return this.selectedSlots.length > 0;
        },
        resetSelection() {
            this.selectedSlots = [];
        },
    };
}

// Register with Alpine before it initialises so x-data="laundryGrid" works
document.addEventListener('alpine:init', () => {
    if (window.Alpine) {
        window.Alpine.data('laundryGrid', laundryGridData);
    }
});

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== 'loading') initInternalArea();
else document.addEventListener('DOMContentLoaded', initInternalArea);